import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflow: "scroll !important",
    height: "100%",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  container: {
    marginTop: 70,
    padding: theme.spacing.space16,
    display: "grid",
    gap: theme.spacing.space24,
  },
  iframe: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    border: "none",
    zIndex: theme.zIndex.dialog,
    background: theme.colors.Background1,
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.6)",
    backdropFilter: "blur(6px)",
    zIndex: theme.zIndex.dialog,
  },
}));
